import {extend} from "../../utils/utils";

import {createArchive} from "../../adapters/archive";
import {createPeriod, createPeriods} from "../../adapters/period";
import {createPools} from "../../adapters/pool";
import {getCurrentPeriod} from "./selectors";


const initialState = {
  current: null,
  periods: null,
  archive: null,
  pools: null,
  dataError: null,
};

const ActionType = {
  LOAD_CURRENT: `LOAD_CURRENT`,
  LOAD_PERIODS: `LOAD_PERIODS`,
  LOAD_ARCHIVE: `LOAD_ARCHIVE`,
  LOAD_POOLS: `LOAD_POOLS`,
  SET_DATA_ERROR: `SET_DATA_ERROR`,
};

const ActionCreator = {
  loadCurrent: (currentPeriod) => ({
    type: ActionType.LOAD_CURRENT,
    payload: currentPeriod,
  }),
  loadPeriods: (periods) => ({
    type: ActionType.LOAD_PERIODS,
    payload: periods,
  }),
  loadArchive: (archivePeriods) => ({
    type: ActionType.LOAD_ARCHIVE,
    payload: archivePeriods,
  }),
  loadPools: (pools) => ({
    type: ActionType.LOAD_POOLS,
    payload: pools,
  }),
  setDataError: (error) => ({
    type: ActionType.SET_DATA_ERROR,
    payload: error,
  }),
};

const Operation = {
  loadCurrent: () => (dispatch, getState, api) => {
    return api.get(`/current`)
      .then((response) => createPeriod(response.data))
      .then((response) => {
        dispatch(ActionCreator.loadCurrent(response));
        return response;
      })
      .catch((error) => {
        dispatch(ActionCreator.setDataError(error));
      });
  },

  loadPeriods: () => (dispatch, getState, api) => {
    return api.get(`/periods`)
      .then((response) => createPeriods(response.data))
      .then((response) => {
        dispatch(ActionCreator.loadPeriods(response));
      })
      .catch((error) => {
        dispatch(ActionCreator.setDataError(error));
      });
  },

  loadArchive: () => (dispatch, getState, api) => {
    return api.get(`/archive`)
      .then((response) => createArchive(response.data))
      .then((response) => {
        dispatch(ActionCreator.loadArchive(response));
      })
      .catch((error) => {
        dispatch(ActionCreator.setDataError(error));
      });
  },

  loadPools: (period) => (dispatch, getState, api) => {
    if (period === ``) {
      period = getCurrentPeriod(getState()).periodId;
    }

    return api.get(`/pools/${period}`)
      .then((response) => createPools(response.data))
      .then((response) => {
        dispatch(ActionCreator.loadPools(response));
      })
      .catch((error) => {
        dispatch(ActionCreator.setDataError(error));
      });
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.LOAD_CURRENT:
      return extend(state, {
        current: action.payload,
      });

    case ActionType.LOAD_PERIODS:
      return extend(state, {
        periods: action.payload,
      });

    case ActionType.LOAD_ARCHIVE:
      return extend(state, {
        archive: action.payload,
      });

    case ActionType.LOAD_POOLS:
      return extend(state, {
        pools: action.payload,
      });

    case ActionType.SET_DATA_ERROR:
      return extend(state, {
        dataError: action.payload,
      });

    default:
      return state;
  }
};


export {
  ActionCreator,
  ActionType,
  Operation,
  reducer,
};
